import React, { lazy } from 'react';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';
import { RouteSuspense } from '@laigu/component';
import { PRIVATIZATION } from '@laigu/constants';

const AuthRoute = lazy(() => import('auth/routes/auth-route'));
const BrandAuth = lazy(() => import('auth/routes/brand-auth-route'));
const Utp = lazy(() => import('auth/pages/utp'));
const Signin = lazy(() => import('auth/pages/signin'));
const Chatlink = lazy(() => import('auth/pages/chatlink'));
const ActivateAccount = lazy(() => import('auth/pages/activate-account'));
const ChangeEmail = lazy(() => import('auth/pages/change-email'));

const ResetPassword = lazy(() => import('auth/pages/reset-password'));
const OpenSignin = lazy(() => import('auth/pages/open-signin'));
const BrandSignin = lazy(() => import('auth/pages/brand-signin'));
const Platform = lazy(() => import('platformApp/pages/index'));
const Channel = lazy(() => import('channel/pages/index'));

const Base = lazy(() => import('base/index'));
const Register = lazy(() => import('auth/pages/register'));
const SigninNoLogo = lazy(() => import('auth/pages/signin-no-logo'));
const DeenSso = lazy(() => import('auth/pages/deen-sso'));
const OpenSso = lazy(() => import('auth/pages/open-sso'));
const Transition = lazy(() => import('@/apps/transit/pages/home'));
const H5Chat = lazy(() => import('@/apps-v2/pages/h5-chat/app'));

const Routes = () => {
  const search = window.location.search;
  const basename = PRIVATIZATION.CUSTOMIZED_PATH;

  return (
    <BrowserRouter basename={basename}>
      <RouteSuspense>
        <Switch>
          <Route path='/auth' component={AuthRoute} />
          {/* 第三方重定向一下 */}
          <Redirect from='/bd-signin' to={{ pathname: '/auth/jump/bd-signin', search }} />
          <Redirect from='/feishu-signin' to={{ pathname: '/auth/jump/feishu-signin', search }} />
          <Redirect from='/bcp-signin' to={{ pathname: '/auth/jump/bcp-signin', search }} />
          <Redirect from='/toutiao-signin' to={{ pathname: '/auth/jump/toutiao-signin', search }} />
          <Redirect from='/open/signin' to={{ pathname: '/auth/jump/360-signin', search }} />
          <Redirect from='/shenma-signin' to={{ pathname: '/auth/jump/shenma-signin', search }} />
          <Redirect from='/fmc-signin' to={{ pathname: '/auth/jump/fmc-signin', search }} />
          <Redirect from='/redbook-signin' to={{ pathname: '/auth/agree-auth', search: search + (search ? '&' : '?') + 'platform=REDBOOK' }} />
          <Route path='/brand-auth' component={BrandAuth} />
          <Route path='/signin' component={Signin} />
          <Route path='/signin_new' component={SigninNoLogo} />
          <Route path='/signin_shunfeng' component={SigninNoLogo} />
          <Route path='/deen-sso' component={DeenSso} />
          <Route path='/open-sso/login' component={OpenSso} />
          <Route path='/change-email' component={ChangeEmail} />
          {/* <Route path="/signup1" component={Register} /> */}
          <Route path='/signup' component={Register} />
          <Route path='/utp' component={Utp} />
          <Route path='/chatlink' component={Chatlink} />
          <Route path='/activate-account' component={ActivateAccount} />
          <Route path='/reset-password' component={ResetPassword} />
          <Route path='/open-signin' component={OpenSignin} />
          <Route path='/brand-signin/:brand' component={BrandSignin} />
          <Route path='/platform' component={Platform} />
          {/* <Route path='/doudian/landing' component={DouyinShopLanding} /> */}
          <Route path='/channel' component={Channel} />
          <Route path='/transit/:type' component={Transition} />
          {/* H5 会话分享页（公开访问，无主应用 layout，token 鉴权） */}
          <Route path='/h5/chat' component={H5Chat} />
          <Route path='/' component={Base} />
          <Redirect to='/' />
        </Switch>
      </RouteSuspense>
    </BrowserRouter>
  );
};

export default Routes;
